import { BoxProps } from "@chakra-ui/react";
import { RowData, Table } from "@tanstack/react-table";
import NumResultsLabel, {
  Props as NumResultsLabelProps,
} from "./NumResultsLabel";
import PaginationControls from "./PaginationControls";
import TableControls, { Props as TableControlsProps } from "./TableControls";
import TableControlsFooter from "./TableControlsFooter";

export type Props<D extends RowData> = BoxProps &
  Pick<NumResultsLabelProps, "totalCount" | "resultTypeLabel"> &
  Pick<TableControlsProps, "isExporting" | "onExport" | "onRefresh"> & {
    isLoading?: boolean;
    tableInstance: Table<D>;
  };

export default function StandardTableControls<D extends RowData>({
  isExporting,
  isLoading,
  onExport,
  onRefresh,
  resultTypeLabel,
  tableInstance,
  totalCount,
  ...rest
}: Props<D>) {
  return (
    <TableControlsFooter
      leftContent={
        <NumResultsLabel
          isLoading={isLoading}
          {...{ totalCount, resultTypeLabel }}
        />
      }
      rightContent={
        <TableControls {...{ isLoading, isExporting, onExport, onRefresh }} />
      }
      {...rest}
    >
      <PaginationControls {...{ tableInstance, isLoading }} />
    </TableControlsFooter>
  );
}
